const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/localhost',
    defaultPath: '/dashboard/default',
    fontFamily: `'Inter', sans-serif`,
    borderRadius: 6
};

export default config;
